import {DownloadRequest, DownloadRequestFile, DownloadRequestParameters, ViewDownloadRequest, ViewDownloadRequestFile} from "@data/interefaces/download.request.interfaces";
import {DownloadRequestProcessStatus} from "@data/enums/data.enums";


export class DownloadRequestUtil {

  public static mapDownloadRequestFileToView(sharePointFolderUrl: string, downloadRequestFile: DownloadRequestFile): ViewDownloadRequestFile {
    let res: ViewDownloadRequestFile = {};
    res.fileName = downloadRequestFile.fileName + "." + downloadRequestFile.contentType?.toLowerCase();
    res.locale = downloadRequestFile.locale;
    res.sharepointFileUrl = sharePointFolderUrl + "/" + res.fileName + "?web=1";
    res.fileDescription = downloadRequestFile.fileDescription;
    res.fileVersion = downloadRequestFile.fileVersion;
    res.fileVersionLabel = downloadRequestFile.fileVersionLabel;
    return res;
  }

  public static mapDownloadRequestToView(downloadRequest: DownloadRequest): ViewDownloadRequest {
    let res: ViewDownloadRequest = {};

    const json = downloadRequest.downloadParameters;
    const parameter: DownloadRequestParameters = {
      ...json, // Spread the existing matching properties
      surveySubject: json.survey_subject,
      reportType: json.report_type
    };
    res.id = downloadRequest.id;
    res.period = parameter.period;
    res.country = parameter.country;
    res.productType = downloadRequest.automatedReport?.automatedReportName;
    res.product = parameter.product;
    res.sponsor = parameter.sponsor;
    res.sponsorName = parameter.sponsorName;
    res.respondentLabels = parameter.respondentSegmentLabels;
    res.language = parameter.language;
    res.requestedBy = downloadRequest.requestedBy;
    res.requestDate = downloadRequest.requestDate;
    res.processStartDate = downloadRequest.processStartDate;
    res.processEndDate = downloadRequest.processEndDate;
    res.priority = downloadRequest.priority;
    res.downloadParameters = JSON.stringify(downloadRequest.downloadParameters);
    res.downloadParametersHash = downloadRequest.downloadParametersHash;
    res.processStatus = downloadRequest.processStatus == DownloadRequestProcessStatus.READY_FOR_DOWNLOAD
      ? DownloadRequestProcessStatus.AVAILABLE
      : downloadRequest.processStatus;
    res.processStatusMessage = downloadRequest.processStatusMessage;
    res.sharepointFolderUrl = downloadRequest.sharepointFolderUrl;
    res.batchCode = downloadRequest.batchCode;
    res.originalBatchCode = downloadRequest.originalBatchCode;
    res.expeditedBy = downloadRequest.expeditedBy;
    res.isLatestRequest = downloadRequest.isLatestRequest;
    res.industryCode = parameter.industryCode;
    res.surveySubject = parameter.surveySubject;
    res.reportType = parameter.reportType;
    res.reportTypeLabel = parameter.reportTypeLabel;
    res.standardReportTypeName = parameter.standardReportTypeName || parameter.reportTypeLabel;
    return res;
  }

  public static handleExpeditedRequests(): void {

  }

  public static isUserAdmin(): boolean {
    return false
  }
}
